
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_143_31)","stroke":"#798f8f","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.5 4.5V6m-3 1.5H6m0 3L10.5 6m-.75 6.75V12m2.024-2.662.976.412M10.5 7.5H12m-4.5 3V12m3.02-4.44c1.33 1.312 1.77 3.022.983 3.82-.788.799-2.504.382-3.835-.93-1.33-1.312-1.77-3.023-.983-3.821s2.504-.382 3.834.93Z"}}),_c('path',{attrs:{"d":"M9.068 17.188v-2.165m0-12.18V.811M.812 8.932h2.03m12.316 0h2.03M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_143_31"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    